/**
 * Return a internal link with language
 * internal link should start with `/`
 * @param {*} language
 * @param {*} target
 * for instances
 * ('en', '/company') => '/company'
 * ('ja', '/company') => '/ja/company'
 * ('ja', 'https://app.liquid.com/sign-up') => 'https://app.liquid.com/sign-up?lang=ja'
 */

import { languages } from '../constants/languages';

const getRedirectLink = (language, target) => {
  // do nothing when language is en
  if (language === 'en') {
    return target;
  }

  // for external link
  if (target.indexOf('http') === 0) {
    return `${target}?lang=${language}`;
  }

  // for internal link
  return `/${language}${target}`;
};

const getLocalizationLink = (language, target) => {
  const link = getRedirectLink(language, target);

  if (typeof window !== 'undefined') {
    const urlLang = window.location.pathname.split('/')[1];
    // In case url has this format www.liquid.com/ko/freeze/?lang=xyz,
    // i18n would prioritize xyz as language, even if it is a random text
    const lang = languages.includes(urlLang) ? urlLang : '';

    const origin = window.location.origin;
    const isEmailAddress = /\S+@\S+/.exec(link);

    if ((link.indexOf('//') !== -1 && !link.startsWith(origin)) || isEmailAddress) {
      return `${origin}/${lang}`;
    }
  }
  return link;
};

export default getLocalizationLink;



// WEBPACK FOOTER //
// ../src/utils/getLocalizationLink.js